// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dz-thumbnail[data-v-66ed59fa]{width:80px}.preview-loading[data-v-66ed59fa]{position:absolute;left:0;top:0;right:0;bottom:0;margin:auto;z-index:2;height:20px}", ""]);
// Exports
module.exports = exports;
